import type { Actor } from "./system";

type LiveMsg = { type: "connect" } | { type: "disconnect" };

const live: Actor<null, LiveMsg> = {
  init: null,
  receive: (state) => state,
};

export default live;
export type { LiveMsg };
